// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgagePartUnderpaymentType.proto

export enum ENUM_MortgagePartUnderpaymentType {
  MORTGAGE_PART_UNDERPAYMENT_TYPE_UNSPECIFIED = 'MORTGAGE_PART_UNDERPAYMENT_TYPE_UNSPECIFIED',
  MORTGAGE_PART_UNDERPAYMENT_TYPE_ONE_TIME = 'MORTGAGE_PART_UNDERPAYMENT_TYPE_ONE_TIME',
  MORTGAGE_PART_UNDERPAYMENT_TYPE_RECURRING = 'MORTGAGE_PART_UNDERPAYMENT_TYPE_RECURRING',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
